export const validation = {
  currentPassword: "Please enter your current password",
  passwordField:
    "Must Contain 8 Characters,\nOne Uppercase, One Lowercase,\nOne Number & special Character",
  newPassword: "Please Enter Your New Password",
  confirmPassword: "Please Enter Your Confirm Password",
};
